module.exports = __webpack_public_path__ + "img/pt.0e4672d2.svg";